import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEmailPlus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconEmailPlus"><Path d="M12 9.83593L2.2075 4H21.7925L12 9.83593Z" fill="currentColor"/><Path d="M2 20V6.20457L12 12.1642L22 6.20457V11H16V14H13V20L2 20Z" fill="currentColor"/><Path d="M20 13V16H23V18H20V21H18V18H15V16H18V13H20Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEmailPlus;
